// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   ProductCard — minimal card, no rounded corners
   ============================================ */

.grb-widget--product-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  background: var(--grb-color-background);
  transition: opacity 0.2s ease;
}

.grb-widget--product-card:hover {
  opacity: 0.85;
}

/* Image wrapper — 3:4 aspect ratio */
.grb-widget--product-image-wrap {
  position: relative;
  width: 100%;
  padding-top: 133%;
  overflow: hidden;
  background: var(--grb-color-background-secondary);
}

.grb-widget--product-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Visual search button on image */
.grb-widget--visual-search-btn {
  position: absolute;
  right: var(--grb-spacing-sm);
  bottom: var(--grb-spacing-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.9);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.grb-widget--product-card:hover .grb-widget--visual-search-btn {
  opacity: 1;
}

.grb-widget--visual-search-btn svg {
  width: 16px;
  height: 16px;
  stroke: var(--grb-color-text);
  fill: none;
}

/* Card content */
.grb-widget--product-info,
.grb-widget--product-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: var(--grb-spacing-sm) var(--grb-spacing-sm) var(--grb-spacing-md);
}

.grb-widget--product-brand {
  font-size: var(--grb-font-size-xs);
  color: var(--grb-color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.grb-widget--product-title {
  font-size: var(--grb-font-size-sm);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.grb-widget--product-prices,
.grb-widget--product-price-row {
  display: flex;
  align-items: baseline;
  gap: var(--grb-spacing-sm);
  margin-top: 2px;
}

.grb-widget--product-price {
  font-size: var(--grb-font-size-lg);
  font-weight: 600;
}

.grb-widget--product-old-price {
  font-size: var(--grb-font-size-xs);
  color: var(--grb-color-text-secondary);
  text-decoration: line-through;
}

.grb-widget--product-sale-price {
  color: var(--grb-color-sale);
}

.grb-widget--product-sizes {
  font-size: var(--grb-font-size-xs);
  color: var(--grb-color-text-secondary);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/styles/product-card.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,iBAAiB;AACjB;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0EAA0E;AAC5E;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["/* ============================================\n   ProductCard — minimal card, no rounded corners\n   ============================================ */\n\n.grb-widget--product-card {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  cursor: pointer;\n  text-decoration: none;\n  color: inherit;\n  background: var(--grb-color-background);\n  transition: opacity 0.2s ease;\n}\n\n.grb-widget--product-card:hover {\n  opacity: 0.85;\n}\n\n/* Image wrapper — 3:4 aspect ratio */\n.grb-widget--product-image-wrap {\n  position: relative;\n  width: 100%;\n  padding-top: 133%;\n  overflow: hidden;\n  background: var(--grb-color-background-secondary);\n}\n\n.grb-widget--product-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Visual search button on image */\n.grb-widget--visual-search-btn {\n  position: absolute;\n  right: var(--grb-spacing-sm);\n  bottom: var(--grb-spacing-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: rgba(255, 255, 255, 0.9);\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.grb-widget--product-card:hover .grb-widget--visual-search-btn {\n  opacity: 1;\n}\n\n.grb-widget--visual-search-btn svg {\n  width: 16px;\n  height: 16px;\n  stroke: var(--grb-color-text);\n  fill: none;\n}\n\n/* Card content */\n.grb-widget--product-info,\n.grb-widget--product-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: var(--grb-spacing-sm) var(--grb-spacing-sm) var(--grb-spacing-md);\n}\n\n.grb-widget--product-brand {\n  font-size: var(--grb-font-size-xs);\n  color: var(--grb-color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.grb-widget--product-title {\n  font-size: var(--grb-font-size-sm);\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.grb-widget--product-prices,\n.grb-widget--product-price-row {\n  display: flex;\n  align-items: baseline;\n  gap: var(--grb-spacing-sm);\n  margin-top: 2px;\n}\n\n.grb-widget--product-price {\n  font-size: var(--grb-font-size-lg);\n  font-weight: 600;\n}\n\n.grb-widget--product-old-price {\n  font-size: var(--grb-font-size-xs);\n  color: var(--grb-color-text-secondary);\n  text-decoration: line-through;\n}\n\n.grb-widget--product-sale-price {\n  color: var(--grb-color-sale);\n}\n\n.grb-widget--product-sizes {\n  font-size: var(--grb-font-size-xs);\n  color: var(--grb-color-text-secondary);\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
